<div class="row">
  <div class="col-lg-4">
    <div>
      <h3>Widget Size</h3>
      <select [(ngModel)]="w.size">
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
        <option value="9">9</option>
        <option value="10">10</option>
        <option value="11">11</option>
        <option value="12">12</option>
      </select>
    </div>
  </div>
  <div class="col-lg-4">
    <h3>URL</h3>
    <input type="text" [(ngModel)]="w.url">
  </div>
</div>
